import { BrowserRouter as Router } from "react-router-dom";
import { withRouter } from "react-router";
import { Fragment } from "react";
import AuthHoc from '../Common/CommonHoc/AuthHoc';
import CentralizedContainer from "../Centralized/CentralizedContainer";
import ProfileSettingsContainer from "../ProfileSettingsV2/profileSettingsContainer";
import SubMenuTab from "../Common/CommonComponents/SubMenuTab/subMenuTab";
import MyAccountDetails from "../Common/CommonComponents/MyaccountDetails/myAccountDetails";
import BillingAndPayment from "./BillingAndPayment/billPayContainer";
import Alerts from "../Common/Alerts/alerts";
import AccountsContainer from './AccountSection/accountContainer';
import AppSpinner from "../Common/CommonComponents/LoadingSpinner/loadingSpinner";
import DownloadBillLoader from "../Common/CommonComponents/DownloadBillSpinner/downloadBillLoader";
import CustomAnchorTag from "../Common/CommonComponents/CustomAnchorTag/customAnchorTag";
import classes from "./settingsContainer.scss";
import DashboardContainerHelper from '../Dashboard/dashboardContainerHelper';
export default class Settings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: "BILLING & PAYMENT", menu_Items: ["BILLING & PAYMENT", "ALERTS & NOTIFICATIONS", "PROFILE"],
            globalError:false,loader:false,showLoader:false,drupalContent:{ineligible_message:"",your_ratePlan:"",toggle_error:"",dss_search_nodata:"", bnp_tech_err:"",isEmpty: true,},
            myaccountDetailsSession: {firstName: " ", lastName: " ", mailingAddress: "", contractAccountNumber: "", mailingAddrsDetails:""}, myAccLandingDtsForBillHelp: this.getMyAccLandingDts(), manageAccDetails:null, isManageAccError:true,totalManageAcc:0,
        };
        this.MENU_ITEMS = ["BILLING & PAYMENT", "ALERTS & NOTIFICATIONS", "PROFILE"];
        this.IS_SINGLE_CA_CN = app.appService.getSessionstorage('isSingleCa'), this.isJointGtTen = app.appService.getSessionstorage("isSingleJointMulti") === "isJointGtTen";
        this.isMultiSingleView;
        this.SELECTED_MENU = "BILLING & PAYMENT";
        this.formatMailingAddress=DashboardContainerHelper.formatMailingAddress.bind(this);
        this.formatMailingAddressPopup=DashboardContainerHelper.formatMailingAddressPopup.bind(this);
        this.capitaliser=DashboardContainerHelper.capitaliser.bind(this);
        this.limitsObject = drupalSettings.custom.globalInformation.setvals.dss_accounts_per_page && !_.isEmpty(JSON.parse(drupalSettings.custom.globalInformation.setvals.dss_accounts_per_page))?JSON.parse(drupalSettings.custom.globalInformation.setvals.dss_accounts_per_page):10;
        this.ACCOUNT_PER_PAGE = this.limitsObject.ManageAccounts_multi ? parseInt(this.limitsObject.ManageAccounts_multi):10;
        this.currentHash="";
        this.backChev = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_chev.svg';
    }

    showAccountsTab = () => {
        if(app.appService.getLocalStorage('totalCact') && app.appService.getLocalStorage('totalCact')!=="undefined"){
            let totalCact= parseInt(app.appService.getLocalStorage('totalCact'));
            this.totalCactCount= totalCact;
            if(parseInt(totalCact)>1){
                this.setState({menu_Items:["BILLING & PAYMENT", "ACCOUNTS", "ALERTS & NOTIFICATIONS", "PROFILE"], isManageAccError: false});
            }}
        else{this.fetchManageAccountDetails();
        }}
    fetchManageAccountDetails = (offSet, limit, sortOption, isService, contractAccountNumber) => {
        app.settingsService.getAccountDetails(isService, contractAccountNumber, sortOption, offSet, limit).then(
            (response) => {
                this.setState({ manageAccDetails: response, isManageAccError:false});
                this.totalCactCount= response.totalCactCount;
                app.appService.setLocalStorage('totalCact', response.totalCactCount);
                if(response.totalCactCount>1){
                    this.setState({menu_Items:["BILLING & PAYMENT", "ACCOUNTS", "ALERTS & NOTIFICATIONS", "PROFILE"], isManageAccError: false});
                } 
            }, (error) => { this.setState({isManageAccError:true});
            });}

    getContentFromDrupal = () => {
        app.contentService.getContent("MYACC_CONTENT").then(
            (response) => {
                let drupalContent = {...this.state.drupalContent};
                _.each(response, (eachContent)=>{
                    if(eachContent.card_name==="your_ratePlan" || eachContent.card_name==="dss_search_nodata" || eachContent.card_name==="toggle_error" || eachContent.card_name==="bnp_tech_err" || eachContent.card_name==="ineligible_message"|| eachContent.card_name === "dss_search_popup"|| eachContent.card_name === "dss_search_label"){
                        drupalContent[eachContent.card_name] = eachContent;
                    }});
        drupalContent.isEmpty = false;
                this.setState({drupalContent: drupalContent,loader:false});
            },
            (error) => {});
 }

    isSingle = (response) => {
        if(response.totalCACTCount === '1' && response.customerAccountList[0].totalContractCount === 1){
            app.appService.setSessionstorage('isSingle', true);
            app.appService.setSessionstorage('acctTypeDSS', 'single');
        }else if(response.totalCACTCount === '1' && response.customerAccountList[0].totalContractCount <= 10){
            app.appService.setSessionstorage('isJoint', true);
            app.appService.setSessionstorage('acctTypeDSS', 'joint');
        }else{
            app.appService.setSessionstorage('isMulti', true);
            app.appService.setSessionstorage('acctTypeDSS', 'multi');
        }
        app.appService.setSessionstorage('totalServiceCount', response.customerAccountList[0].totalContractCount);}

    componentDidMount() {
        this.currentHash = location.hash;
        this.setState({loader:true});
        this.userGroup = app.appService.getPrioritisedUserGrp();
        this.isMyAccUser = (this.userGroup === app.appUtil.getAppConstants().USER_GROUPS.MYACCOUNT);
        if(this.isMyAccUser) this.showAccountsTab();
        this.getContentFromDrupal();
        if((this.isMyAccUser) && (_.isEmpty(this.IS_SINGLE_CA_CN) || _.isEmpty(this.isMultiSingleView))) {
            let that = this;
            app.settingsService.getServiceAccounts().then(
                (response) => {
                     let userInfo = app.appService.getUserInfo();
                    if(sessionStorage.getItem("myaccountDetails") === null && response.STDCACTCount==="1"){
                        app.settingsService.getBillingAccountsDetails().then(
                            (response) => {
                                if (response.totalCustomerAccountCount === 1) {
                                    let custName = response.customerAccountListData[0].customerAccountName,
                                        custNameHasComma = custName.includes(','),
                                        nameSplit = custNameHasComma ? custName.split(',').map(part => part.trim()) : custName,
                                        mailingAddress = this.formatMailingAddress(response.customerAccountListData[0].mailingAddress);
                                    let mailingAddressPopup = this.formatMailingAddressPopup(response.customerAccountListData[0].mailingAddress);
                                    this.setMyAccountDetailsData(response.customerAccountListData[0].customerAccountName, response.customerAccountListData[0].customerAccountAddress, response.customerAccountListData[0].contractAccountNumber, mailingAddress);
                                    app.appService.setSessionstorage('myaccountDetails', { firstName: custNameHasComma ? nameSplit[1].charAt(0).toUpperCase() + nameSplit[1].slice(1).toLowerCase() : nameSplit, lastName: custNameHasComma ? nameSplit[0].charAt(0).toUpperCase() + nameSplit[0].slice(1).toLowerCase() : '', mailingAddress: mailingAddress, mailingAddressPopup: mailingAddressPopup, contractAccountNumber: response.customerAccountListData[0].contractAccountNumber });}
                            }, (error) => { this.setState({showLoader: false }); });}
                    const acctCategory= response.customerAccountList[0].serviceAccountList[0].servicePlanType === app.appUtil.getAppConstants().CUSTOMER_CLASS? app.appUtil.getAppConstants().residential:app.appUtil.getAppConstants().Business;
                    const acctType = response.totalCACTCount> 1 ? app.appUtil.getAppConstants().MY_ACCOUNT.ACCOUNT_TYPE_MULTI : app.appUtil.getAppConstants().MY_ACCOUNT.ACCOUNT_TYPE_SINGLE;
                    if(acctType === app.appUtil.getAppConstants().MY_ACCOUNT.ACCOUNT_TYPE_SINGLE){
                        app.analyticsService.addPageLevelData('accountType',acctCategory+' | '+acctType, '');
                    userInfo.accountType = (acctCategory + ' | ' + acctType);
                    app.appService.setUserInfo(userInfo);}
                    that.IS_SINGLE_CA_CN = response.totalCACTCount === '1' ? 'true' : 'false';
                    that.isMultiSingleView = (parseInt(response.totalCACTCount) > 1 && response.STDCACTCount === '1') ? true : false, that.isJointGtTen =  (parseInt(response.STDCACTCount) === 1 && parseInt(response.customerAccountList[0].totalContractCount) > 10) ? true : false;
                    this.isSingle(response);
                    let myAccLandingDtsForBillHelp = {...this.state.myAccLandingDtsForBillHelp};
                    if(!myAccLandingDtsForBillHelp.isDataSet){
                        myAccLandingDtsForBillHelp.contractAccountNumber = response.customerAccountList[0].contractAccountNumber,
                        myAccLandingDtsForBillHelp.contractNumber = response.customerAccountList[0].serviceAccountList[0].contractNumber,
                        myAccLandingDtsForBillHelp.contractBpNumber = response.customerAccountList[0].businessPartnerNumber,
                        myAccLandingDtsForBillHelp.isRateTOU = response.customerAccountList[0].serviceAccountList[0].currentServicePlan.split('-')[0].toLowerCase().indexOf(app.appUtil.getAppConstants().MY_ACCOUNT.TOU)!==-1 ? true : false,
                        myAccLandingDtsForBillHelp.isRes = response.customerAccountList[0].serviceAccountList[0].servicePlanType === 'RES',
                        myAccLandingDtsForBillHelp.isDataSet = true,
                        myAccLandingDtsForBillHelp.nbtVintageYear = response.customerAccountList[0].serviceAccountList[0].nbtVintageYear,  //initalized billingRateType to restrict budget assiatnce enrollment for NBTV, NBTA, NEMV, NEMA as part of NBT4.
                        myAccLandingDtsForBillHelp.billingRateType = response.customerAccountList[0].serviceAccountList[0].billingRateType;
                    }
                    this.setState({showLoader: false, myAccLandingDtsForBillHelp:{...myAccLandingDtsForBillHelp},totalManageAcc:parseInt(response.STDCACTCount)});
                }, (error) => { this.setState({showLoader: false});
                });
        } else this.setState({showLoader: false});
    }  
    setTotalMngAcc=(val)=>{
        this.isMultiSingleView = (val === 1) ? true : false;
        this.scrollPos = window.scrollY;
        this.setState({totalManageAcc:val});} // reduced lines 
    componentDidUpdate(prevProps,prevState){
        if(prevState.totalManageAcc !== this.state.totalManageAcc){
            window.scrollTo(0,this.scrollPos);}} // reduced lines
    onMenuChange = (e, subMenu, index) => {
        switch(subMenu) {
            case "ALERTS & NOTIFICATIONS":
            this.capturingAnalytics('settings|none|none|none|page|alerts_and_notification');
            this.SELECTED_MENU = "ALERTS & NOTIFICATIONS";
            this.setState({selected:"ALERTS & NOTIFICATIONS"});
            this.goToPreferenceCneter();
            break;
            case "PROFILE":
            this.SELECTED_MENU = "PROFILE";
            this.capturingAnalytics('settings|none|none|none|page|profile_settings'); 
            this.setState({selected:"PROFILE"});
            this.props.history.push("#profile");
            break; 
            case "ACCOUNTS":
            this.SELECTED_MENU = "ACCOUNTS";
            this.capturingAnalytics('settings|none|none|none|page|accounts'); 
            this.setState({selected:"ACCOUNTS"});
            this.props.history.push("#accounts");     
            break;  
            default:
            this.SELECTED_MENU = "BILLING & PAYMENT";
            this.capturingAnalytics('settings|none|none|none|page|billing_and_payment');
            this.setState({selected:"BILLING & PAYMENT"});
            this.props.history.push('#billsnpayments');
        }
    }

    goToPreferenceCneter = () => {
        this.props.history.push('#preferences');
    }

    getCurrentModule = () => {
        this.currentHash !== location.hash ? window.scrollTo(0,0) : null;
        let inputtedAccTab =  this.props.location.hash.indexOf("#accounts") !== -1?true:false,
        loadAccountsTab = this.props.location.hash.indexOf("#accounts") !== -1 && this.totalCactCount>1;//False if totalCactCount <=1 and redirect, when inputted Accounts tab for single A/c
        switch(true){
            case loadAccountsTab: {
                    let events = {
                        alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'settings'
                    };
                    app.analyticsService.addPageLevelData('eventCapturing', events);
                    this.SELECTED_MENU = "ACCOUNTS";
                    return <AccountsContainer setTotalMngAcc={this.setTotalMngAcc.bind(this)} totalManageAcc={this.state.totalManageAcc} drupalContent={this.state.drupalContent} manageAccDetails={this.state.manageAccDetails} showAccountsTab={this.showAccountsTab} accountsPerPage={this.ACCOUNT_PER_PAGE} vintageYear={this.state.myAccLandingDtsForBillHelp.nbtVintageYear} />;

                }
            case this.props.location.hash.indexOf("#preferences") !== -1: {
            let events = {
                alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'settings'
            };
            app.analyticsService.addPageLevelData('eventCapturing', events);
            this.SELECTED_MENU = "ALERTS & NOTIFICATIONS";
            return this.isMyAccUser ? <div className={classes.sceMainPadding}><CentralizedContainer noBanner billingRateType={this.state.myAccLandingDtsForBillHelp.billingRateType} /></div> : <div><CentralizedContainer billingRateType={this.state.myAccLandingDtsForBillHelp.billingRateType} /></div>;}
            case this.props.location.hash.indexOf("#profile") !== -1:{
                let events = {
                    alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:true, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'settings'
                };
                app.analyticsService.addPageLevelData('eventCapturing', events);
            this.SELECTED_MENU = "PROFILE";
            return this.isMyAccUser ? <div className={classes.sceMainPadding}><ProfileSettingsContainer noBanner /></div> : <div><ProfileSettingsContainer /></div>;}
            default: {
            inputtedAccTab ?  this.props.history.push('#billsnpayments'):null;
            let events = {
                alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'settings'
            };
            app.analyticsService.addPageLevelData('eventCapturing', events);
            this.SELECTED_MENU = "BILLING & PAYMENT";
            return <BillingAndPayment goToPreferenceCneter={this.goToPreferenceCneter} setMyAccountDetailsData={this.setMyAccountDetailsData} content={this.state.drupalContent} myAccLandingDtsForBillHelp={this.state.myAccLandingDtsForBillHelp} />;}
        }}
    capturingAnalytics=(linkName)=>{
        if(window.aUtils){
                window.aUtils.sendAAEvent("navClick", `${linkName}`);
        }
    }

    setMyAccountDetailsData = (customerAccountName,customerAccountAddress,contractAccountNumber,mailingAddrsDetails) => {
        let myaccountDetailsSession = {...this.state.myaccountDetailsSession};
        let custName =  customerAccountName,
        custNameHasComma = custName.includes(','),
        nameSplit = custNameHasComma ? custName.split(',').map(part => part.trim()) : custName,
            mailingAddress= customerAccountAddress.split(' ').map((word,index) =>{
                if(index === customerAccountAddress.split(' ').length-2)
                return word.toUpperCase();
                else{
                    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();}
                }).join(" ");
            mailingAddress=mailingAddress.split('-')[0];
            myaccountDetailsSession.firstName = custNameHasComma ? nameSplit[1].charAt(0).toUpperCase() + nameSplit[1].slice(1).toLowerCase() : nameSplit;
            myaccountDetailsSession.lastName =  custNameHasComma ? nameSplit[0].charAt(0).toUpperCase() + nameSplit[0].slice(1).toLowerCase() : '';
            myaccountDetailsSession.mailingAddress = mailingAddress;
            myaccountDetailsSession.contractAccountNumber = contractAccountNumber;
            myaccountDetailsSession.mailingAddrsDetails=mailingAddrsDetails;
        this.setState({myaccountDetailsSession: myaccountDetailsSession});
    }
    backToMyAccount=()=>{
        let dashboardPage=app.appService.getSessionstorage('dashboardPage');
        dashboardPage === null ? null : app.appService.setSessionstorage('dashboardPage', { 'currentPage': dashboardPage.currentPage, 'sortDirection': dashboardPage.sortDirection, 'fromBackToAccount': true });
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().MYACCOUNT.MYACCOUNT_LANDINGPAGE);
    }

    getMyAccLandingDts = () => {
        let landingDts = {isRateTOU: false, isRes: false, contractAccountNumber: "", contractNumber: "", contractBpNumber: "", nbtVintageYear: "", billingRateType: "", isDataSet: false};
        let myAccLandingResponseSes = app.appService.getSessionstorage('myAccLandingResponse');

        if(!_.isEmpty(myAccLandingResponseSes)) {
            landingDts.contractAccountNumber = myAccLandingResponseSes.customerAccountList[0].contractAccountNumber,
            landingDts.contractNumber = myAccLandingResponseSes.customerAccountList[0].serviceAccountList[0].contractNumber,
            landingDts.contractBpNumber = myAccLandingResponseSes.customerAccountList[0].businessPartnerNumber,
            landingDts.isRateTOU = myAccLandingResponseSes.customerAccountList[0].serviceAccountList[0].currentServicePlan.split('-')[0].toLowerCase().indexOf(app.appUtil.getAppConstants().MY_ACCOUNT.TOU)!==-1 ? true : false,
            landingDts.isRes = myAccLandingResponseSes.customerAccountList[0].serviceAccountList[0].servicePlanType === 'RES',
            landingDts.isDataSet = true,
            landingDts.nbtVintageYear = myAccLandingResponseSes.customerAccountList[0].serviceAccountList[0].nbtVintageYear, //initalized billingRateType to restrict budget assiatnce enrollment for NBTV, NBTA, NEMV, NEMA as part of NBT4.
            landingDts.billingRateType = myAccLandingResponseSes.customerAccountList[0].serviceAccountList[0].billingRateType;
        }
        return landingDts;
    }

    getViewToShow = () => {
        let currentModule, viewToshow=null,otherElem=null;
        if(!this.state.drupalContent.isEmpty){
        currentModule = this.getCurrentModule();
        let loader = this.state.loader?<DownloadBillLoader />:null;
        if(this.isMyAccUser){
        if(this.IS_SINGLE_CA_CN === "true" || this.IS_SINGLE_CA_CN === true || this.isMultiSingleView === true || this.isJointGtTen === true){
            otherElem = 
                <Fragment>
                    {(this.props.location.hash.indexOf("#accounts") !== -1 || (this.isMultiSingleView === true && this.props.location.hash.indexOf('#preferences') !== -1)) ? null: <MyAccountDetails firstName={this.state.myaccountDetailsSession.firstName} lastName={this.state.myaccountDetailsSession.lastName} contractAccountNumber={this.state.myaccountDetailsSession.contractAccountNumber}
                        mailingAddress={this.state.myaccountDetailsSession.mailingAddress} mailingAddrsDetails={this.state.myaccountDetailsSession.mailingAddrsDetails} />}
                    <div className={classes.sceMainPadding}><div className={classes.sceAlertsSec}><Alerts isDrupalOnlyAlerts /></div></div>
                    <SubMenuTab header={'Settings'} subHeaders={this.state.menu_Items} selected={this.SELECTED_MENU} onMenuItemChange={this.onMenuChange} />
                    {/* {currentModule} */}
                </Fragment>;
        } else if(_.isEmpty(this.isMultiSingleView) && !this.isJointGtTen) {    
            let moduleName = app.appService.getSessionstorage('dashboardPage');    
            otherElem = 
            <Fragment>
                {loader}
                <div className={classes.sceMainPadding}><Alerts isDrupalOnlyAlerts /></div>
                {moduleName && moduleName.billPayFlag && this.SELECTED_MENU ==="BILLING & PAYMENT"  ? <div className={classes.sceMainPadding}><span><img className={classes.sceBackchevImg} src={this.backChev} alt="Chev Icon" /></span><CustomAnchorTag linkName={'Back to Customer Account Overview'} onClick={this.backToMyAccount} /></div>:null}
                <SubMenuTab header={'Settings'} subHeaders={this.state.menu_Items} selected={this.SELECTED_MENU} onMenuItemChange={this.onMenuChange} /> 
            </Fragment>;
        }} else {
            otherElem = <div id="alert_section" />;}}//Alert section id added for page break tracking
        viewToshow=<Fragment>{otherElem}{currentModule}</Fragment>;
        return viewToshow;}

    render(){
        let viewToshow = this.state.showLoader ? <AppSpinner /> : this.getViewToShow();
        return (
            viewToshow
        );
    }

}

const url = app.appUtil.getQueryParameters(window.location.href);
const SettingsWithRouter = (url && url.token && url.oktaId) ? withRouter(Settings) :  AuthHoc(withRouter(Settings), true);
(function () {
  AppModule.init(fetchLibs);
  app.appUtil.setFontAwesomeNesting();
})();

function fetchLibs() {
  app.appUtil.appDependencyService.loadDependencyLibs(renderComponent, 31);
}

function renderComponent() {
  ReactDOM.render(
    <Router>
      <SettingsWithRouter />
    </Router>,
    document.getElementById("react-settings")
  );
}
